<template>
    <div class="c-header-practice-results">
        <h2 class="c-header-practice-results__h">Pratik Sonuçları</h2>
        <button class="btn-close-practice-results" @click="closeResults">
            <svg class="btn-close-results__icon" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.567 11.366l-4.37-4.365 4.37-4.364A1.544 1.544 0 1011.384.452L7.01 4.82 2.636.452A1.544 1.544 0 10.453 2.637L4.823 7l-4.37 4.365a1.544 1.544 0 102.183 2.185L7.01 9.183l4.374 4.368c.301.3.696.45 1.092.45a1.543 1.543 0 001.091-2.635z" fill="#FFFFFF"/></svg>
        </button>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        methods: {
            closeResults(){
                this.$emit('closeResults');
                this.$router.push('/practice-modes');
            }
        }
    };
</script>

<style scoped src="@/css/components/c-header-practice-results.css"></style>